import { HttpErrorResponse } from '@angular/common/http';
import { Component, inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CardModule } from 'primeng/card';
import { mergeMap, tap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserLogged } from '../../../../models/user/user-logged';
import { UserRepository } from '../../../../repositories/user/user.repository';
import { LoadingComponent } from '../../../../shared/components/loading/loading.component';
import { AuthService } from '../../auth.service';

@Component({
  selector: 'app-auth-call-back',
  standalone: true,
  imports: [LoadingComponent, TranslateModule, CardModule],
  templateUrl: './auth-call-back.component.html',
  styleUrls: ['./auth-call-back.component.scss'],
})
export class AuthCallBackComponent implements OnInit {
  private readonly userRepository = inject(UserRepository);
  private readonly authService = inject(AuthService);
  private readonly router = inject(Router);

  ngOnInit(): void {
    this.authService
      .storeTokensFromRedirect()
      .pipe(
        mergeMap(() => this.userRepository.login()),
        tap((user: UserLogged) => {
          this.authService.loggedUser(user);
        }),
        mergeMap(() => this.authService.handleRedirect()),
        catchError((err: HttpErrorResponse) => {
          if (err.status === 401 || err.status === 403) {
            void this.router.navigate(['/unauthorized']);
          } else if (err.status === 500) {
            void this.router.navigate(['/maintenance']);
          } else {
            void this.router.navigate(['/error']);
          }
          return throwError(() => err);
        }),
      )
      .subscribe();
  }
}
